import React from 'react'
import userDataBg from 'components/Discover/images/user-data-bg.jpg'

const ModalBackground = () => (
  <div
    className="fixed left-0 top-0 z-100 bg-center bg-cover"
    style={{
      width: '100vw',
      height: '100vh',
      backdropFilter: 'blur(10px)',
      backgroundImage: `url(${userDataBg})`,
    }}
  >
    <div className="bg-black bg-opacity-70 w-full h-full" />
  </div>
)

export default ModalBackground
